import i18n from '@/i18n';
import { useWorkspaceStore } from '@/stores/useWorkspaceStore';
import { watch } from 'vue';

export const updateHtmlLangPlugin = () => {
  const workspaceStore = useWorkspaceStore();

  const syncWorkspaceStoreLocaleToI18nGlobalLocale = () =>
    (i18n.global.locale.value = workspaceStore.currentLocale);
  const updateHtmlLang = () =>
    (document.documentElement.lang = workspaceStore.currentLocale);

  const syncLocale = () => {
    syncWorkspaceStoreLocaleToI18nGlobalLocale();
    updateHtmlLang();
  };

  watch(
    () => workspaceStore.currentLocale,
    () => syncLocale(),
  );

  syncLocale();
};
